<template>
  <div>
  <meta name="viewport" content="width=device-width,initial-scale=1.0">
    <div class="bmdiv mat tc6">
      <div class="tdiv bgw pb20">
        <div class="fs30 nm bg-red twhite fbold tcenter">丽水技师学院新生报到信息登记</div>
        <div class="txt pl35 pr35" v-if="flow==1">
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的家长朋友、同学们：</div>
            <div class="tdent lh17">为了提高我校智慧校园管理水平，方便教职工和学生的工作和生活，我校全面推行校园一卡通的使用，为了方便同学们报到，需要补充信息登记工作，请填写身份证号后进行信息补充。</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证号</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写身份证号" v-model="cid">
          </div>
          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="getCardInfo">立即查询</a>
          </div>
        </div>
        <div class="xt pl35 pr35" v-else-if="flow == 2"><!-- 该学生已被录取(学生已满16周岁) -->
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的{{info.name}}：</div>
            <div class="tdent lh17">为了提高我校智慧校园管理水平，方便教职工和学生的工作和生活，我校全面推行校园一卡通的使用，为了方便同学们报到，需要补充信息登记工作，请填写身份证号后进行信息补充。</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生姓名<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的姓名（必填）" v-model="info.name" disabled="disabled">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生身份证号<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的学生身份证号（必填）" v-model="info.id_card" disabled="disabled">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">出生年月</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="出生年月" v-model="info.birthday" type="date">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生拼音/姓(大写)<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="（必填）例如：'张三'填写ZHANG" v-model="info.lastname">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生拼音/名(大写)<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="（必填）例如：'张三'SAN" v-model="info.firstname">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生证件到期日<font color="red">（*）</font></label>
            <div class="dflex between">
              <select  style="max-width: 30%;"class="input border-dd bg-f4 br2" name="" v-model="info.expiration_status">
                <option value="0">限期</option>
                <option value="1">长期/永久</option>
              </select>
              <input v-if="info.expiration_status == 1" class="dblock input border-dd bg-f4 br2 wd80" name="" placeholder="请填写学生的证件到期日（必填）" type="date" disabled>
              <input v-else class="dblock input border-dd bg-f4 br2 wd80" name="" placeholder="请填写学生的证件到期日（必填）" v-model="info.expiration_date" type="date">
            </div>

          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">手机号码<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的手机号码（必填）" v-model="info.phone">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">证件地址</label>
            <div class="dflex between">
              <select  style="max-width: 30%;"class="input border-dd bg-f4 br2" name="" v-model="info.country">
                <option value="">国家</option>
                <option v-for="(item,index) in country" :value="index">{{item}}</option>
              </select>
              <select style="max-width: 35%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.province" @change="()=>{info.city='';this.getCity();}">
                <option value="">省份</option>
                <option v-for="(item,index) in province" :value="index">{{item}}</option>
              </select>
              <select style="max-width: 30%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.city">
                <option value="">城市</option>
                <option v-for="(item,index) in city" :value="index">{{item}}</option>
              </select>
            </div>
            <input class="dblock input border-dd bg-f4 br2 wd100" style="margin-top: 10px" name="" placeholder="详细地址" v-model="info.address">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证正面<font color="red">*</font></label>
            <input ref="id_card_front" type="file" @change="getFrontFiles($event)" accept="image/*" />
            <input type="text" class="input border-dd bg-f4 br2 wd80" disabled :value="(id_card_front!='')?id_card_front:info.id_card_front"/>
            <a class="zbtn bg-red twhite fs15 br2" style="width: 15%;padding: 5px 0;vertical-align: top;" href="javascript:;" @click="changeFront">上传</a>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证反面<font color="red">*</font></label>
            <input ref="id_card_back" type="file" @change="getBackFiles($event)" accept="image/*" />
            <input type="text" class="input border-dd bg-f4 br2 wd80" disabled :value="(id_card_back!='')?id_card_back:info.id_card_back"/>
            <a class="zbtn bg-red twhite fs15 br2" style="width: 15%;padding: 5px 0;vertical-align: top;" href="javascript:;" @click="changeBack">上传</a>
          </div>
          <div class="warn-div">
            以下信息是为军训服装做准备，请准确填写
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生身高<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写身高（厘米，必填）" v-model="info.height" type="number">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生体重<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写体重（千克，必填）" v-model="info.weight" type="number">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生鞋码<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写鞋码（码，必填）" v-model="info.shoes_size" type="number">
          </div>
          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="subInfo()">提交</a>
          </div>
        </div>
        <div class="xt pl35 pr35" v-else-if="flow == 3"><!-- 该学生已被录取(学生未满16周岁) -->
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的{{info.name}}：</div>
            <div class="tdent lh17">为了提高我校智慧校园管理水平，方便教职工和学生的工作和生活，我校全面推行校园一卡通的使用，为了方便同学们报到，需要补充信息登记工作，请填写身份证号后进行信息补充。</div>
          </div>
          <div class="warn-div">
            注意：您的孩子未满16周岁，为了更好的推进智慧校园一卡通使用，方便学生在校管理、就餐、门禁和图书借阅等环节，我校统一为家长办理一张中国银行借记卡，专门用于您的孩子校园一卡通充值、查询等。因此务必填写当天陪同孩子报到的家长身份信息。
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生姓名<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的姓名（必填）" v-model="info.name" disabled="disabled">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生身份证号<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的学生身份证号（必填）" v-model="info.id_card" disabled="disabled">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">出生年月</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="出生年月" v-model="info.birthday" type="date">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">校园卡申领家长姓名<font color="red">（报到陪同家长姓名*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写家长姓名（必填）" v-model="info.applicant">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长拼音/姓(大写)<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="（必填）例如：'张三'填写ZHANG" v-model="info.lastname">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长拼音/名(大写)<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="（必填）例如：'张三'填写SAN" v-model="info.firstname">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长身份证号<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写陪同家长身份证号（必填）" v-model="info.applicant_id_card">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长证件到期日<font color="red">（*）</font></label>
            <div class="dflex between">
              <select  style="max-width: 30%;"class="input border-dd bg-f4 br2" name="" v-model="info.expiration_status">
                <option value="0">限期</option>
                <option value="1">长期/永久</option>
              </select>
              <input v-if="info.expiration_status == 1" class="dblock input border-dd bg-f4 br2 wd80" name="" placeholder="请填写学生的证件到期日（必填）" type="date" disabled>
              <input v-else class="dblock input border-dd bg-f4 br2 wd80" name="" placeholder="请填写学生的证件到期日（必填）" v-model="info.expiration_date" type="date">
            </div>
          </div>

          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长手机号码<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写陪同家长手机号码（必填）" v-model="info.phone">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长证件地址<font color="red">（*）</font></label>
            <div class="dflex between">
              <select  style="max-width: 30%;"class="input border-dd bg-f4 br2" name="" v-model="info.country">
                <option v-for="(item,index) in country" :value="index">{{item}}</option>
              </select>
              <select style="max-width: 35%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.province" @change="()=>{info.city='';this.getCity();}">
                <option value="">省份</option>
                <option v-for="(item,index) in province" :value="index">{{item}}</option>
              </select>
              <select style="max-width: 30%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.city">
                <option value="">城市</option>
                <option v-for="(item,index) in city" :value="index">{{item}}</option>
              </select>
            </div>
            <input class="dblock input border-dd bg-f4 br2 wd100" style="margin-top: 10px" name="" placeholder="详细地址" v-model="info.address">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长身份证正面<font color="red">*</font></label>
            <input ref="id_card_front" type="file" @change="getFrontFiles($event)" accept="image/*" />
            <input type="text" class="input border-dd bg-f4 br2 wd80" disabled :value="(id_card_front!='')?id_card_front:info.id_card_front"/>
            <a class="zbtn bg-red twhite fs15 br2" style="width: 15%;padding: 5px 0;vertical-align: top;" href="javascript:;" @click="changeFront">上传</a>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">陪同家长身份证反面<font color="red">*</font></label>
            <input ref="id_card_back" type="file" @change="getBackFiles($event)" accept="image/*" />
            <input type="text" class="input border-dd bg-f4 br2 wd80" disabled :value="(id_card_back!='')?id_card_back:info.id_card_back"/>
            <a class="zbtn bg-red twhite fs15 br2" style="width: 15%;padding: 5px 0;vertical-align: top;" href="javascript:;" @click="changeBack">上传</a>
          </div>
          <div class="warn-div">
            以下信息是为军训服装做准备，请准确填写
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生身高<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写身高（厘米，必填）" v-model="info.height" type="number">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生体重<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写体重（千克，必填）" v-model="info.weight" type="number">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">学生鞋码<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写鞋码（码，必填）" v-model="info.shoes_size" type="number">
          </div>
          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="subInfo()">提交</a>
          </div>
        </div>
        <div class="message" v-else-if="flow == 4">
          <div class="msg1">操作成功</div>
          <div class="msg2">扫码关注学校官方微信公众号，更多学校资讯以及信息将通过公众号进行发布。</div>
          <div class="msg_img"><img src="../assets/images/ls_wx.jpg"/></div>
          <div class="msg3">丽水技师学院</div>
        </div>
      </div>
      <div class="bdiv bgw mt10 fs15 tc9 tcenter pt10 pb10">
        <div class="fbold">丽水技师学院</div>
        <div>Copyright&nbsp;&copy;&nbsp;2021 丽水技师学院</div>
        <div>招生办电话0578-2306000、2306111、2306222</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sign",
  data(){
    return {
      info:{
        name:'',
        level:'',
        id_card:'',
        birthday:'',
        applicant:'',
        applicant_identity:'',
        lastname:'',
        firstname:'',
        phone:'',
        applicant_id_card:'',
        expiration_date:'',
        country:0,
        province:'',
        city:'',
        address:'',
        id_card_front:'',
        id_card_back:'',
        height:'',
        weight:'',
        shoes_size:'',
        expiration_status:0,
      },
      subing:0,
      flow:1,
      cid:'',
      id_card_front_blod:'',
      id_card_front_files:[],
      id_card_front:'',
      id_card_back_blod:'',
      id_card_back_files:[],
      id_card_back:'',
      province:{},//省
      city:{},//市
      country:{
        '中国':'中国',
      },//国家
    }
  },
  created() {
    this.cid = this.$route.query.cid;
    this.getProvince();
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].className="bm_body";
  },
  methods:{
    getAddress(pid,success){
      var getParam = {}
      getParam['parent_id'] = pid
      this.$request.get('get-region',getParam,success)
    },
    getProvince(){
      this.getAddress(0,response => {
        if(response.data.code == 200){
          this.province = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    getCity(){
      this.getAddress(this.info.province,response => {
        if(response.data.code == 200){
          this.city = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    subInfo:function(){
      if(this.subing == 1){
        return false;
      }
      this.subing = 1;
      if(!this.info.id_card_front && !this.id_card_front){
        this.subing = 0;
        alert('身份证正面未上传');return false;
      }
      if(!this.info.id_card_back && !this.id_card_back){
        this.subing = 0;
        alert('身份证反面未上传');return false;
      }

      let param = new FormData();
      if(this.id_card_front_files.length > 0){
        this.info.id_card_front = this.id_card_front;
        param.append('id_card_front',this.id_card_front_blod,this.id_card_front_files[0].name);//压缩后的图片
        // param.append('id_card_front',this.id_card_front_files[0],this.id_card_front_files[0].name);
      }
      if(this.id_card_back_files.length > 0){
        this.info.id_card_back = this.id_card_back;
        param.append('id_card_back',this.id_card_back_blod,this.id_card_back_files[0].name);
        // param.append('id_card_back',this.id_card_back_files[0],this.id_card_back_files[0].name);
      }
      for(let key in this.info){
        param.append(key,this.info[key]);
      }
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
      this.$request.postFile('bank-info-submit',param,config,response => {
        if(response.status == 200 && response.data.code == 200){
          //报名成功
          this.flow = 4;
        }else{
          alert(response.data.message);
        }
        this.subing = 0;
      },error => {
        alert('系统错误');
        console.log(error);
        this.subing = 0;
      })
    },
    getFrontFiles:function(e){
      this.id_card_front_files = e.target.files
      this.id_card_front = '';
      for (let i=0; i < e.target.files.length;i++){
        this.id_card_front += e.target.files[i]['name']+';'
      }
      var file = this.id_card_front_files[0];
      var img = new Image()
      img.onload=() => {
        var blob = this.$request.compressImg(img, file.type, 800, 800)
        this.id_card_front_blod = blob;
      }
      this.$request.readImg(img,file);
    },
    getBackFiles:function(e){
      this.id_card_back_files = e.target.files
      this.id_card_back = '';
      for (let i=0; i < e.target.files.length;i++){
        this.id_card_back += e.target.files[i]['name']+';'
      }
      var file = this.id_card_back_files[0];
      var img = new Image()
      img.onload=() => {
        var blob = this.$request.compressImg(img, file.type, 800, 800)
        this.id_card_back_blod = blob;
      }
      this.$request.readImg(img,file);

    },
    changeFront:function(){
      this.$refs.id_card_front.dispatchEvent(new MouseEvent('click'))
    },
    changeBack:function(){
      this.$refs.id_card_back.dispatchEvent(new MouseEvent('click'))
    },
    getCardInfo(){
      var getParam = {}
      getParam['id_card'] = this.cid
      this.$request.get('bank-info-detail',getParam,(response)=>{
        if(response.data.code == 200){
          for(var ind in this.info){
            this.info[ind] = response.data.data[ind];
          }
          this.getCity();
          if(this.info.applicant_identity == 1){
            this.flow = 2;
          }else if(this.info.applicant_identity == 2){
            this.flow = 3;
          }else{
            alert('学生信息错误，无法判断是否满16周岁')
          }
        }else{
          alert(response.data.message);
        }
      })
    },
  },
  watch:{
  }
}
</script>

<style scoped>
  .bmdiv{width: 95%;max-width: 430px;}
  .bmdiv .nm{height: 100px;line-height: 100px;font-size: 200%;}
  .bmdiv .inputdiv{margin-bottom: 20px;}
  .bmdiv .inputdiv input[type=file]{display: none;}
  .bmdiv input,.bmdiv select{line-height: 32px;height: 32px;}
  .bmdiv .wd100{width: 100%;}
  .bmdiv .wd80{width: 80%;}
  .bmdiv .txt{padding: 0 6%;min-height: 550px;}
  .bmdiv .tdent{text-align: justify;}
  .bmdiv .between{justify-content: space-between;}
  .bmdiv .input:focus{background-color: #fff;border: 1px solid #94070a;box-shadow: 0 0 8px #94070a;}
  .bmdiv textarea{width: 570px;height: 300px;resize: vertical;}
  .bmdiv .zbtn{padding: 7px 45px;width: 80%;}
  .message{height: 600px;}
  .message .msg1{font-size: 26px;padding-left: 20px;padding-right: 20px;margin-top: 110px;text-align: center;font-weight: bolder;}
  .message .msg1 span{font-size: 24px;color: #000;}
  .message .msg2{font-size: 18px;padding-left: 50px;padding-right: 50px;margin-top: 20px;}
  .message .msg2 span{color: red;}
  .message .msg_img{margin-top: 40px;width: 100%}
  .message .msg_img img{width: 200px;height: 200px;display: block;margin: 0 auto;}
  .message .msg3{text-align: center;margin-top: 40px;font-size: 20px;}
  .message .msg3 span{color:red;}
  .success {text-align: center;}
  .suc1{margin-top: 170px;}
  .suc2{font-size: 26px;color: #000;font-weight: bold;margin-top: 20px;}
  .suc3{line-height: 24px;}
  .suc4{margin-top: 60px;}
  .suc4 a{margin:0 auto;display:block;line-height:48px;background: #fff;border: 2px solid #979797;color: #2b2b2b;width: 154px;height: 52px;border-radius: 8px;font-size: 18px;margin-bottom: 150px;}
  .nt{padding: 10px 30px;line-height: 1.6;text-align: justify;font-size: 15px;}
  .warn-div{
    border: 1px solid rgb(210,216,230);
    border-left: 2px solid rgb(147,204,186);
    padding: 6px;
    margin-bottom: 10px;
  }
</style>
<style>
.bm_body{min-width: auto;background: #f2f2f2;}
</style>



// WEBPACK FOOTER //
// src/pages/reg.vue